module.exports = __webpack_public_path__ + "static/media/1.a2d38482.ogg";